module.exports = __webpack_public_path__ + "img/bg01.d86eb1d6.jpg";